@if (csvTemplates && csvTemplates.length) {
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z0">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>
        {{ translationService.getNameText() }}
      </th>
      <th></th>
      <td mat-cell *matCellDef="let template">
        {{ template.name }}
      </td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let template">
        <button (click)="showFieldMappings(template)">
          {{ translationService.getViewText() }}
        </button>
        <button (click)="goToEdit(template.id)">
          {{ translationService.getEditText() }}
        </button>
        <button (click)="delete(template.id, template.name)">
          {{ translationService.getDeleteText() }}
        </button>
        <button (click)="download(template.id, template.name)">
          {{ translationService.getDownloadText() }}
        </button>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  <mat-paginator
    showFirstLastButtons
    pageSize="5"
    hidePageSize="true"
  ></mat-paginator>
}
